import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { LogistikOrderItem } from '@chancenwerk/db/LogistikOrder.js';
import '@chancenwerk/design/components/cr-image.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { g_getProductCategoryString } from '../../../../src/logistik/client/helper.js';

/**
 * @customElement logistik-component-order-item-card
 */
@customElement('logistik-component-order-item-card')
export class LogistikComponentOrderItemCard extends ChemistryLitElement {
  @state() public item = new RXController(this, new LogistikOrderItem({}));
  @state() private isEditing = false;
  @state() private quantity = -1;

  override render() {
    if (!this.item.value) return html`<cr-text>Item not found</cr-text>`;
    return html`
      <cr-card padding="sm" ${css({ width: '100%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)' })}>
        <cr-flex space="sm" horizontal crossaxis-center>
          <cr-image disabled value=${this.item.value.product.imageID} mode="width" ${css({ width: '60px' })}></cr-image>
          <cr-flex horizontal flex crossaxis-center space="xl">
            <cr-flex flex space="sm">
              <cr-text bold>
                <!-- //! use better check for product category -->
                ${g_getProductCategoryString(this.item.value.product._class)}
              </cr-text>
              <cr-text ${css({ lineHeight: '18px' })}>${this.item.value.product.title}</cr-text>
            </cr-flex>
            <cr-flex horizontal space="sm" crossaxis-center>
              ${this.isEditing
                ? Input(
                    this.item.value.quantity,
                    (e: CustomEvent<{ value: number }>) => (this.quantity = e.detail.value),
                  )
                : Text(this.item.value.quantity)}
              ${this.isEditing
                ? IconButton('check', 'Anzahl speichern', () => {
                    this.isEditing = false;
                    if (this.quantity >= 0) this.dispatchQuantityChangedEvent();
                  })
                : IconButton('edit', 'Anzahl editieren', () => {
                    this.isEditing = true;
                  })}
            </cr-flex>
          </cr-flex>
        </cr-flex>
      </cr-card>
    `;
  }

  private dispatchQuantityChangedEvent() {
    this.dispatchEvent(
      new CustomEvent('quantity-changed', {
        detail: { quantity: this.quantity },
        bubbles: true,
        composed: true,
        cancelable: true,
      }),
    );
  }
}

const quantityWidth = '60px';
const Input = (value: number, valueChanged: (event: CustomEvent<{ value: number }>) => void): Renderable => html`
  <cr-input
    placeholder="Anzahl"
    type="number"
    .value=${value}
    ${css({ width: quantityWidth })}
    @value-changed=${(e: CustomEvent<{ value: number }>) => valueChanged(e)}
  >
  </cr-input>
`;
const Text = (value: number): Renderable =>
  html` <cr-flex crossaxis-end ${css({ width: quantityWidth })}> <cr-text bold> x${value} </cr-text> </cr-flex> `;

const IconButton = (icon: string, tooltip: string, cb: () => void): Renderable => html`
  <cr-button mode="icon" icon="${icon}" @click=${() => cb()}>
    <cr-tooltip>
      <cr-text> ${tooltip} </cr-text>
    </cr-tooltip>
  </cr-button>
`;
